/* eslint-disable react-hooks/exhaustive-deps */
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import styled from '@emotion/styled';
import SegmentEventsUtil from '@utils/SegmentEventsUtils';
import { segment } from '@actions/analytics';
import useGoalEventProps from '@hooks/useGoalEventProps';
import { useSnackbar } from '@stores/snackbar';
import { useRouter } from 'next/router';
import { DOW2_SOLUTION_REVIEW } from '@constants/segment';

const Iframe = styled.iframe`
  height: 663px;
`;

const DoubtSolutionPlayer = ({
  // eslint-disable-next-line no-unused-vars
  liveClassData,
  goalUID,
  onReady,
  className,
  additionalEvtData,
  doubtUID,
  solutionUID,
  recordingURL
}) => {
  const router = useRouter();
  const selectedSolutionUID = solutionUID;
  const goalSegmentData = useGoalEventProps({ goalUID });
  const [isLoaded, setIsLoaded] = useState(false);

  const { open: showSnackbar } = useSnackbar();

  const onMessageReceived = (e) => {
    if (e.data.liveClassReady) {
      document
        .getElementById('solutionCanvas')
        ?.contentWindow?.postMessage(liveClassData, '*');
      onReady();
    }
    if (e.data.eventType === 'SEGMENT_EVENTS') {
      const eventName = e.data.eventData.name;
      const clxEventData = e.data.eventData.data;
      let eventData = {
        name: eventName
      };

      if (eventName === DOW2_SOLUTION_REVIEW) {
        eventData = {
          ...eventData,
          doubt_id: doubtUID,
          doubt_type: 'Doubts AI',
          feature_version: 2,
          flow_type: 'Non_Demo',
          solution_uid: selectedSolutionUID,
          doubt_subject_selection: 'NA',
          doubt_subject_changed: 'NA',
          subject: 'NA'
        };
      }

      const combData = {
        ...goalSegmentData,
        ...clxEventData,
        ...eventData
      };
      segment.track(eventName, combData);
    } else if (e.data.eventType === 'START_RECORDING_ERROR')
      showSnackbar({
        message: e.data.errorDescription || 'Active room already exists',
        type: 'error'
      });
    else if (e.data.eventType === 'CLOSE_IFRAME') {
      router.back();
    } else if (e.data.eventType === 'RELOAD_IFRAME') {
      window.location.reload();
    } else if (e.data.segmentEvents) {
      SegmentEventsUtil.sendEvent(e.data.eventData, additionalEvtData);
    }
  };
  useEffect(() => {
    if (!isLoaded) setIsLoaded(true);
    window.addEventListener('message', onMessageReceived);
    return () => {
      window.removeEventListener('message', onMessageReceived);
    };
  }, [solutionUID]);

  if (!isLoaded) return null;
  return (
    <Iframe
      src={recordingURL}
      id="solutionCanvas"
      webkitallowfullscreen="true"
      allowFullScreen
      width="100%"
      height="563px"
      autoPlay
      frameBorder="no"
      title="Canvas"
      className={className}
    />
  );
};

export default DoubtSolutionPlayer;

DoubtSolutionPlayer.propTypes = {
  recordingURL: PropTypes.string.isRequired,
  liveClassData: PropTypes.objectOf(PropTypes.any),
  className: PropTypes.string,
  onReady: PropTypes.func,
  additionalEvtData: PropTypes.objectOf(PropTypes.any),
  goalUID: PropTypes.string.isRequired
};

DoubtSolutionPlayer.defaultProps = {
  liveClassData: {},
  className: '',
  onReady: () => {},
  additionalEvtData: {}
};
